import styled from 'styled-components';

export const Notice = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  min-height: 0;
  overflow: hidden;
  color: #34333d;
  font-family: 'Montserrat', 'Segoe UI', sans-serif;
`;

export const Header = styled.header`
  position: relative;
  display: flex;
  flex: 0 0 auto;
  min-height: 114px;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  overflow: hidden;
  padding: 20px 22px;
  background: #5b259d;
  color: #ffffff;

  &::before {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: 150px;
    background:
      linear-gradient(90deg, rgba(255, 255, 255, 0.09) 0 34%, transparent 34% 67%, rgba(0, 0, 0, 0.08) 67%),
      linear-gradient(145deg, transparent 0 30%, rgba(255, 255, 255, 0.08) 30% 57%, transparent 57%);
    content: '';
  }
`;

export const Heading = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  gap: 2px;
  line-height: 1.1;

  span {
    font-size: 25px;
    font-weight: 500;
  }

  strong {
    color: #fff200;
    font-size: 28px;
    font-weight: 700;
  }
`;

export const Logo = styled.img`
  position: relative;
  z-index: 1;
  width: 142px;
  height: auto;
  filter: brightness(0) invert(1);
`;

export const Body = styled.section`
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  padding: 18px 22px 12px;
  background: #ffffff;
  font-size: 13.5px;
  line-height: 1.18;

  p {
    margin: 0 0 13px;
  }

  p:last-child {
    margin-bottom: 0;
  }

  strong {
    color: #5b259d;
    font-weight: 700;
  }

  @media (max-width: 520px) {
    padding-right: 16px;
    padding-left: 16px;
    font-size: 13px;
  }
`;

export const Footer = styled.footer`
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  min-height: 52px;
  padding: 8px 16px;
  background: #5b259d;
`;

export const FooterButton = styled.button`
  display: inline-flex;
  min-width: 38px;
  height: 34px;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(255, 255, 255, 0.9);
  border-radius: 4px;
  background: transparent;
  color: #ffffff;
  cursor: pointer;
  font-family: inherit;
  font-size: 14px;
  font-weight: 700;
  line-height: 1;

  &:hover,
  &:focus {
    background: rgba(255, 255, 255, 0.14);
    outline: none;
  }

  &:focus-visible {
    box-shadow: 0 0 0 2px #ffffff, 0 0 0 4px #5b259d;
  }
`;
